export default __webpack_public_path__ + "static/media/frontBalls.03b57ce5.png";